import React from 'react'

import CompactTokensList from '@src/pages/Exchange/components/SelectTokenModal/components/CompactTokensList'
import { sortTokensByPriority } from '@src/pages/Exchange/components/SelectTokenModal/utils'
import { IToken } from '@src/types/token'

interface TokenCategoriesDisplayProps {
    displayedTokens: IToken[]
    selectedToken?: IToken
    onTokenClicked: (token: IToken) => void
    getTokenBalance?: (token: IToken) => { tokenBalance: string; usdBalance: string } | undefined
}

export const TokenCategoriesDisplay: React.FC<TokenCategoriesDisplayProps> = ({
    displayedTokens,
    selectedToken,
    onTokenClicked,
    getTokenBalance,
}) => {
    const tokensWithBalance = displayedTokens.filter(token => token.userBalanceInUSD && token.userBalanceInUSD > 0)
    const tokensWithoutBalance = displayedTokens.filter(
        token => !token.userBalanceInUSD || token.userBalanceInUSD === 0
    )

    return (
        <div className='animate-fadeIn space-y-4'>
            {/* Tokens with balances */}
            {tokensWithBalance.length > 0 && (
                <div className='space-y-1'>
                    <div className='px-2'>
                        <h3 className='animate-slideInRight text-sm font-medium text-token-modal-label-text'>
                            Your Tokens
                        </h3>
                    </div>
                    <CompactTokensList
                        tokens={sortTokensByPriority(tokensWithBalance)}
                        selectedToken={selectedToken}
                        onTokenClicked={onTokenClicked}
                        getTokenBalance={getTokenBalance}
                    />
                </div>
            )}

            {/* All tokens */}
            <div className='space-y-1'>
                <div className='px-2'>
                    <h3 className='animate-slideInRight text-sm font-medium text-token-modal-label-text'>All Tokens</h3>
                </div>
                <CompactTokensList
                    tokens={sortTokensByPriority(tokensWithoutBalance)}
                    selectedToken={selectedToken}
                    onTokenClicked={onTokenClicked}
                    getTokenBalance={getTokenBalance}
                />
            </div>
        </div>
    )
}

export default TokenCategoriesDisplay
